import React, { useState } from 'react';
import { ArrowLeftIcon, CheckIcon } from 'lucide-react';
import { CalendarIcon, MapPinIcon, ClockIcon } from 'lucide-react';
interface SharedListViewProps {
  onBack: () => void;
  onSaveEvent: (eventName: string) => void;
}
export function SharedListView({
  onBack,
  onSaveEvent
}: SharedListViewProps) {
  const [savedEvents, setSavedEvents] = useState<Set<number>>(new Set());
  // Demo shared events
  const sharedEvents = [{
    id: 1,
    name: 'Summer Rooftop Concert',
    date: '2024-06-15',
    time: '19:00',
    location: 'Sky Lounge, Downtown',
    category: 'music'
  }, {
    id: 2,
    name: 'Art Gallery Opening',
    date: '2024-06-16',
    time: '18:00',
    location: 'Modern Art Museum',
    category: 'art'
  }, {
    id: 3,
    name: 'Food Truck Festival',
    date: '2024-06-17',
    time: '12:00',
    location: 'Central Park',
    category: 'food'
  }, {
    id: 4,
    name: 'Beach Volleyball Tournament',
    date: '2024-06-17',
    time: '14:00',
    location: 'Venice Beach',
    category: 'sports'
  }];
  const formatDate = (dateString: string) => {
    const [year, month, day] = dateString.split('-').map(num => parseInt(num, 10));
    const date = new Date(Date.UTC(year, month - 1, day, 12, 0, 0));
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric'
    });
  };
  const formatTime = (timeString: string) => {
    const [hours, minutes] = timeString.split(':').map(num => parseInt(num, 10));
    let period = hours >= 12 ? 'pm' : 'am';
    let hours12 = hours % 12;
    if (hours12 === 0) hours12 = 12;
    return minutes === 0 ? `${hours12}${period}` : `${hours12}:${minutes.toString().padStart(2, '0')}${period}`;
  };
  const handleSave = (eventId: number, eventName: string) => {
    setSavedEvents(prev => new Set(prev).add(eventId));
    onSaveEvent(eventName);
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-599">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-4 py-4" data-id="element-600">
        <button onClick={onBack} className="flex items-center text-gray-600 hover:text-gray-900 mb-4" data-id="element-601">
          <ArrowLeftIcon className="w-5 h-5 mr-2" data-id="element-602" />
          Back
        </button>
        <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-603">Weekend Plans</h1>
        <div className="flex items-center" data-id="element-604">
          <div className="w-8 h-8 bg-purple-600 rounded-full flex items-center justify-center text-white text-sm font-semibold mr-2" data-id="element-605">
            JD
          </div>
          <p className="text-sm text-gray-600" data-id="element-606">Shared by Jordan Davis</p>
        </div>
      </div>

      {/* Event cards */}
      <div className="px-4 py-6 space-y-4 max-w-lg mx-auto" data-id="element-607">
        {sharedEvents.map(event => {
        const isSaved = savedEvents.has(event.id);
        return <div key={event.id} className="bg-white rounded-lg shadow p-4 border border-gray-200" data-id="element-608">
              <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-609">
                {event.name}
              </h3>

              <div className="space-y-2 mb-4" data-id="element-610">
                <div className="flex items-center text-sm text-gray-600" data-id="element-611">
                  <CalendarIcon className="w-4 h-4 mr-2 text-gray-400" data-id="element-612" />
                  {formatDate(event.date)}
                </div>
                <div className="flex items-center text-sm text-gray-600" data-id="element-613">
                  <ClockIcon className="w-4 h-4 mr-2 text-gray-400" data-id="element-614" />
                  {formatTime(event.time)}
                </div>
                <div className="flex items-center text-sm text-gray-600" data-id="element-615">
                  <MapPinIcon className="w-4 h-4 mr-2 text-gray-400" data-id="element-616" />
                  {event.location}
                </div>
              </div>

              <button onClick={() => handleSave(event.id, event.name)} disabled={isSaved} className={`w-full py-2.5 rounded-lg font-medium transition-colors ${isSaved ? 'bg-green-100 text-green-800 cursor-default' : 'bg-purple-600 text-white hover:bg-purple-700'}`} data-id="element-617">
                {isSaved ? <span className="flex items-center justify-center" data-id="element-618">
                    <CheckIcon className="w-5 h-5 mr-2" data-id="element-619" />
                    Saved
                  </span> : 'Save to my events'}
              </button>
            </div>;
      })}
      </div>
    </div>;
}